module.exports = __webpack_public_path__ + "assets/img/box3-img.5f9ecda4.png";